import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

function RemoveEmergentBadge() {
  useEffect(() => {
    const removeBadge = () => {
      const elements = document.querySelectorAll("div, span, a");
      elements.forEach((el) => {
        if (el.textContent && el.textContent.includes("Made with Emergent")) {
          let target = el;
          // Target the outer container of the badge
          while (target && target.parentElement && target !== document.body) {
            if (target.style && (target.style.position === "fixed" || target.style.position === "absolute" || target.classList.toString().includes("emergent"))) {
              break;
            }
            if (target.parentElement.children.length === 1) {
              target = target.parentElement;
            } else {
              break;
            }
          }
          target.remove();
        }
      });
    };

    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RemoveEmergentBadge />
    <App />
  </React.StrictMode>,
);